import { CardMediaProps, useCardMedia } from "./useCardMedia";

const CardMedia = (props: CardMediaProps) => {
  const renderElement = useCardMedia(props);
  return renderElement;
};

export default CardMedia;
